/**
 * Created by hardy on 2018/2/7.
 */

//聊天模块
import api from '../../fetch/api'
import WS from '../../libs/chat'
import *  as types from '../types'
import Vue from 'vue'
import { MessageBox } from 'element-ui';
const chat = {
  state : {
    messageList : [],
    chatData : [],
    //存储当前的连接
    conn :'',
    //   聊天对方的一些信息
    is_relogin : true,
    patInfo : '',
    //  历史记录的时间
    recordTime : 0,
    //  显示的时间
    showTime : 0,
    //  聊天分页
    page : 1,
    //  用户的服务状态
    patService : {},
    //  用户是否登录聊天的状态
    isLoginChat : false,
    //  滚动插件状态
    scrollTo : 'bottom',
    // 群发时候已发送的条数
    groupNewsCount : 0
  },
  getters :{
    msgCount: state=>{
      let count = 0 ,orderCount = 0 ,reportCount = 0,indentCount = 0;
      (state.messageList).forEach((v,i)=>{
        if (v.from === 'patientReport') {
          reportCount += v.unread_num;
        } else if (v.from === 'patientAppoint') {
          orderCount += v.unread_num;
        } else if (v.from === 'patientOrder') {
          indentCount += v.unread_num;
        }
        count += v.unread_num;
      })
      count -= reportCount;
      return {count,orderCount,reportCount,indentCount};
    },
    chatDataIndex : state=>{
      return state.chatData.length-1;
    }
  },
  mutations : {
    [types.UPDATE_MESSAGE_LIST](state,payload){
      state.messageList = [];
      // console.log(payload);
      // payload.forEach((v)=>{
      //   if(v.from.split('_')[1]){
      //     v.face =  `${PATLINKAPI}/patient/face/${v.from.split('_')[1]}?${Date.parse(new Date())}`;
      //   }
      // })
      state.messageList = Object.assign([],payload);
    },
    [types.IS_LOGIN_CHAT](state,payload){
      state.isLoginChat = payload;
    },
    [types.UPDATE_CHAT_SERVICE](state,payload){
      //转化剩余天数
      let start = payload.order_start;
      let end = payload.order_end;
      let  replay = payload.replay_time;
      payload.data = {};
      // let obj;
      if(payload) {
        payload.data = {};
      }
      // }else{
      //   obj = {
      //     data : {
      //       type : 'chat_replay_tip'
      //     },
      //     count_remain: "1",  //剩余次数
      //     count_usage: "1",  //购买时可用次数，0无限
      //     order_end: 1512403199, //服务开始时间
      //     order_start: 1504512512,  //服务结束时间
      //     order_status: "4",  // 服务状态2进行中3取消4结束
      //     order_type: "3",  //服务类型2图文咨询（按次）3图文咨询（按期）4随访/免费
      //     replay_status: "2", //医生回复状态1新咨询2待回复3已回复
      //     replay_time: ""  //医生最后回复时间
      //   }
      //   state.patServiceSet = obj;
      // }
      if(start == end){
        payload.day = 0;
        payload.hour = 0;
      }else{
        if(end == 0){
          payload.day = -0;
          payload.hour = -0;
        }else{
          let starttime = Date.parse(new Date()).toString();
          starttime = starttime.substr(0,10);
          let endtime = payload.order_end;
          let timeCha = Math.ceil((endtime-starttime)/86400);
          let timeCha2 = Math.ceil((endtime-payload.order_start)/86400);
          if(timeCha == timeCha2){
            --timeCha;
          }
          payload.day = timeCha;
          if(replay == ''){
            payload.hour = 0;
          }else{
            payload.hour =  Math.ceil((Date.parse(new Date()) - parseInt(`${replay}000`)) /(60 * 60 * 1000 ));
          }
        }
      }
      payload.data.type = 'chat_replay_tip';
      state.patService = payload;
    },
    [types.UPDATE_CHAT_DATA](state,payload){
      if(payload && payload.data){
        let lastTime  = parseInt(state.showTime);
        let time = parseInt(payload.data.timestamp);
        let timer =  new Date();
        let res = new RegExp(timer.getFullYear() +'/'+(timer.getMonth()+1)+'/'+timer.getDate());
        if (lastTime == 0  || (time-lastTime) > 300000) {
          state.showTime = time;
          time = new Date(parseInt(time)).toLocaleString().replace(/:\d{1,2}$/,' ');
          time= time.replace(res,'');
          if(time){
            if(/GMT\+8/.test(time)){
              time = time.replace(/GMT\+8/,'');
            }
          }
          payload.data.time = time;
        }else{
          payload.data.time = '';
        }
      }
      state.chatData.push(payload);
    },
    [types.UPDATE_CHAT_RECORD](state,payload){
      let lastTime  = parseInt(state.recordTime);
      let time = parseInt(payload.data.timestamp);
      let timer =  new Date();
      let res = new RegExp(timer.getFullYear() +'/'+(timer.getMonth()+1)+'/'+timer.getDate());
      if (lastTime == 0  || (time-lastTime) < -300000) {
        state.recordTime = time;
        time = new Date(parseInt(time)).toLocaleString().replace(/:\d{1,2}$/,' ');
        time= time.replace(res,'');
        if(time){
          if(/GMT\+8/.test(time)){
            time = time.replace(/GMT\+8/,'');
          }
        }
        payload.data.time = time;
      }else{
        payload.data.time = '';
      }
      state.chatData.unshift(payload);
    },
    [types.UPDATE_CHAT_PATINFO](state,payload){
      state.patInfo = payload;
    },
    [types.SET_CHAT_CONN](state,payload){
      state.conn = payload;
    },
    [types.CLEAR_CHAT_STATE](state){
      state.chatData = [];
      state.patInfo = '';
      state.recordTime = 0;
      state.showTime = 0;
      state.page = 0
    }
  },
  actions : {
    connConfig({commit,state,rootState,dispatch}){
      let docAcc = rootState.docInfo.hx_account;
      //判断是否有accout 决定是否做登录处理
      if(docAcc){
        commit('IS_LOGIN_CHAT',true);
        let conn = new WS();
        api.chatToken()
          .then(obj=>{
            //连接配置
            conn.init(`${CHATLINK}?chat_token=${obj.chat_token}`,docAcc);
            commit('SET_CHAT_CONN',conn);
            conn.listen({
              // 连接成功的回调
              onOpen : function(){
                conn.login();
              },
              // 登录成功之后的回调
              onLogin : function(mes){
                // 聊天基本设置
                conn.chatMsgSet({origin : 'chat', chatType : 'single' , from : docAcc ,to : state.patInfo.hx_account});
              },
              // 接收到文本消息
              onTextMessage : function(mes){
                dispatch('storeMessage',{type :'text',msg : mes});
                // _this.handleMessage('text',mes);
              },
              onImgMessage : function(mes){
                dispatch('storeMessage',{type :'img',msg : mes});
                commit('SET_IMG_ARR',{way : 'push' , msg : mes},{root : true})
              },
              onVoiceMessage : function(mes){
                dispatch('storeMessage',{type :'voice',msg : mes});
              },
              onChartMessage : function(mes){
                dispatch('storeMessage',{type :'chart',msg : mes});
              },
              onDataMessage : function(mes){

              },
              // 收到解除和添加关系
              onRelation : function(mes){
                commit('IS_UPDATE_CONTACTS',true);
                dispatch('handlePresence',{type :'relation',msg : mes});
                // _this.handlePresence(mes);
              },
              onSysMessage : function (mes) {
                dispatch('storeMessage',{type :'system',msg : mes});
              },
              // 收到文本的阅读状态
              onReadState : function(mes){
                dispatch('storeMessage',{type :'text',msg : mes});
              },
              // 收到消息是否发送成功状态
              onSendState : function(data){
                switch (data.code){
                  case  2000:
                    console.log('在线消息发送成功');
                    dispatch('storeMessage1',{type :data.data.data.type,msg : data.data});
                    if(data.data.data.type == 'img'){
                      commit('SET_IMG_ARR',{way : 'push' , msg : data.data},{root : true});
                    }
                    // _this.handleMessage(data.data.data.msgType,data.data,'sendSuccess');
                    break;
                  case  2001:
                    console.log('在线消息发送失败')
                    break;
                  case  2010:
                    console.log('离线消息发送成功')
                    dispatch('storeMessage1',{type :data.data.data.type,msg : data.data});
                    if(data.data.data.type == 'img'){
                      commit('SET_IMG_ARR',{way : 'push' , msg : data.data},{root : true});
                    }
                    // _this.handleMessage(data.data.data.msgType,data.data,'sendSuccess');
                    break;
                  case  2011:
                    console.log('离线消息发送失败')
                    // dispatch('storeMessage',{type :data.data.data.msgType,msg : mes});
                    break;
                  case  2100:
                    console.log('消息发送中');
                    break;
                  case  2101:
                    console.log('消息发送失败');
                    break;
                }
              },
              // 连接失败
              onError : function(mes){
                console.log(mes);
              },
              // 连接失败
              onClose : function(mes){
                // MessageBox.confirm('您已断开连接,是否重新连接？').then(()=>{
                  dispatch('connConfig');
                // })
              },
              // 被挤下线的回调
              onOffLine : function(mes){
                  MessageBox.confirm('您已断开连接,是否重新登录？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    dispatch('connConfig');
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // });
                  }).catch();
              }
            })
          })
      }
    },
    //收到收到会员或者其他端的消息的消息
    storeMessage({commit,rootGetters,state,dispatch,rootState},obj){
      state.scrollTo = 'bottom';
      rootState.updateUnReplay = true;
      // dispatch('unReplayCount');
      let type = obj.type , msg = obj.msg , newss , data = msg.data , message = state.messageList;
      let selfId = rootGetters.docAcc;
      let url = window.location.href;
      let isChat = /chat/g.test(url);
      let selfMessage;
      switch (type) {
        case 'img':
          newss = '[图片]';
          break;
        case 'chart':
          newss = '[图表]';
          break;
        case 'data':
          newss = '[测评]';
          break;
        case 'voice':
          newss = '[语音]'
          break;
        default :
          newss =  data.text;
          break;
      }
      if(type == 'system'){
        msg.from = msg.action;
      }
      if((data.type == 'patient_order'  || data.type == 'inquiry_service' || data.type == 'family_service' ) ){
        dispatch('updateDocInfo');
        if(data.type == 'inquiry_service' || data.type == 'family_service'){
          api.gIndentDetail(data.order_no).then(obj1=>{
            if(data.from == state.patInfo.hx_account){
              commit('UPDATE_CHAT_SERVICE',obj1.data);
            }
          })
        }else{
          if(state.patInfo.account && /chat/.test(document.URL)){
            api.patInfo(state.patInfo.account).then(obj1=>{
              if(data.from == state.patInfo.hx_account){
                commit('UPDATE_CHAT_SERVICE',obj1.order);
              }
            })
          }
        }
      }
      //patient_order是咨询结束的消息  咨询结束不需要
      if(data.type != 'patient_order' && type != 'system'){
        if((msg.from == rootState.docInfo.hx_account && msg.to == state.patInfo.hx_account)  || (msg.to == rootState.docInfo.hx_account && msg.from == state.patInfo.hx_account)){
          //  收到其他端的消息
          commit('UPDATE_CHAT_DATA',msg);
        }
      }
    },
    //收到发送消息的成功的返回
    storeMessage1({commit,rootGetters,rootState,state,dispatch},obj){
      state.scrollTo = 'bottom';
      rootState.updateUnReplay = true;
      // dispatch('unReplayCount');
      let type = obj.type , msg = obj.msg , newss , data = msg.data , message = state.messageList;
      if(type != 'img'){
        // 将本地的未发出去的消息清空；
        let m =  JSON.parse(window.localStorage['errMessage']);
        delete m[rootState.docInfo.account][state.patInfo.account][msg.id];
        window.localStorage['errMessage'] = JSON.stringify(m);
      };
      let url = window.location.href;
      let isChat = /chat/g.test(url);
      switch (type) {
        case 'text':
          newss = data.text;
          break;
        case 'img':
          newss = '[图片]';
          // state.chatData[data.index].data.text.src = data.text.src;
          break;
        case 'chart':
          newss = '[图表]';
          break;
        case 'data':
          newss = '[测评]';
          break;
        case 'voice':
          newss = '[语音]'
          state.chatData[data.index].data.text.src = data.text.src;
          break;
        case 'doctorOrderTime':
          newss = '[门诊预约时间表]'
          break;
        case 'requestDeviceData':
          newss = "[请求肺功能检测数据]";
          break;
        case 'popularArticle':
          newss = "[科普文章]";
          Toast('发送成功！');
          break;
      }
      //要存在本地的消息列表
      let obj1 = {
        from : msg.to,
        to : msg.from,
        name : data.toName,
        text : newss,
        timestamp : `${msg.timestamp.toString()}000`,
        version : msg.version
      }
      //将 发送状态变更掉
      state.chatData[data.index].data.sendStatus = true;
      let result =  message.some((vv,ii)=>{
        //判断消息来源是否在原来数据中存在
        if(vv.from == msg.to){
          let obj2 =  message[ii];
          Object.assign(obj2,obj1);
          message =message.removeByValue(message[ii]);
          obj2.unread_num ++;
          //是否是聊天界面
          if(isChat) {
            //是否是当前聊天对象
            if (msg.to == state.patInfo.hx_account) {
              obj2.unread_num = 0;
              // commit('UPDATE_CHAT_DATA',msg);
            }
          }
          message.unshift(obj2);
          commit('UPDATE_MESSAGE_LIST',message);
        }
        return  vv.from == msg.to;
      })
      if(!result){
        //是否是聊天界面
        if(isChat){
          //是否是当前的聊天对象
          if(msg.to == state.patInfo.hx_account){
            obj1.unread_num = 0;
          }else{
            obj1.unread_num = 1;
          }
        }
        //不是聊天界面
        else{
          obj1.unread_num = 1;
        }
        obj1.name = state.patInfo.name ? state.patInfo.name : state.patInfo.nick;
        obj1.account = state.patInfo.account;
        obj1.headimg = state.patInfo.headimg;
        message.unshift(obj1);
        console.log(message);
        commit('UPDATE_MESSAGE_LIST',message);
      }
    },
    sendMsg({commit,state,rootState},payload){
      state.scrollTo = 'bottom';
      state.is_send = false;
      let i = payload.index;
      return new Promise((resolved)=>{
        api.getRelation({id : state.patInfo.account})
          .then(obj=>{
            //说明双方是好友关系
            if(obj.relation == '4'){
              let msg = JSON.parse(JSON.stringify(payload.msg));
              Object.assign(msg.data,{
                fromName : rootState.docInfo.name,
                toName : msg.data.toName || state.patInfo.remark_name || state.patInfo.name || state.patInfo.nick,
                index : i,
                readyState : null
              });
              delete msg.data.sendStatus;
              delete msg.data.relation;
              state.conn.send(msg);
              state.chatData[i].data.relation = '';
              state.chatData[i].data.sendStatus = true
            }else{
              state.chatData[i].data.sendStatus = true;
              state.chatData[i].data.relation = obj.relation;
            }
          })
        resolved('');
      })
    },
    updatePatinfo({commit,dispatch,state},payload){
      return new Promise((resolve)=>{
        if(payload){
          //清除掉之前所有数据
          commit('CLEAR_CHAT_STATE');
          api.patInfo(payload)
            .then(obj=>{
              //更新用户信息
              commit('UPDATE_CHAT_PATINFO',obj.info);
              commit('UPDATE_CHAT_SERVICE',obj.order);
              resolve(obj);
            })
        }else{
          resolve();
        }
      })
    },
    updateChatSet({state,rootState}){
      if(state.conn){
        state.conn.chatMsgSet({origin : 'chat', chatType : 'single' , from : rootState.docInfo.hx_account ,to : state.patInfo.hx_account});
      }
    },
    clearCount({commit,rootGetters,state},payload){
      return new Promise((resovle)=>{
        let message = state.messageList;
        message.forEach((vv,ii)=>{
          if(vv.from == payload){
            vv.unread_num = 0;
          }
        })
        commit('UPDATE_MESSAGE_LIST',message);
        resovle();
      })
    },
    gainRecord({commit,rootState,state}){
      //        初始化聊天相关的信息
      let timestamp = Date.parse(new Date());
      let page = 1;
      //清除掉之前的img
      commit('SET_IMG_ARR',{way : 'clear' },{root : true});
      return new Promise((resolve)=>{

        api.newChatRecord(state.patInfo.account,{page,timestamp})
          .then(obj=>{
            let length = obj.chats.length;
            for(let i = length-1 ; i > -1 ; i--){
              commit('UPDATE_CHAT_DATA',obj.chats[i]);
              if(obj.chats[i].data.type == 'img'){
                commit('SET_IMG_ARR',{way : 'push' ,msg : obj.chats[i]},{root : true});
              }
              if(obj.chats[i].data.type == 'inquiry_service'){
                if(obj.chats[i].data.ill_imgs.length != 0){
                  let ill_img = obj.chats[i].data.ill_imgs;
                  for(let j= 0; j < ill_img.length ; j ++){
                    commit('SET_IMG_ARR',{way : 'push' ,msg : ill_img[j].path},{root : true});
                  }
                }
                if(obj.chats[i].data.drug_imgs.length != 0){
                  let drug_img = obj.chats[i].data.drug_imgs;
                  for(let k= 0; k < drug_img.length ; k ++){
                    commit('SET_IMG_ARR',{way : 'push' ,msg : drug_img[k].path},{root : true});
                  }
                }
              }
            }
            let msg = window.localStorage['errMessage'];
            if(msg && JSON.parse(msg)[rootState.docInfo.account]){
              msg = JSON.parse(msg)[rootState.docInfo.account][state.patInfo.account];
              for (let key in msg){
                if(msg[key].id){
                  msg[key].data.sendStatus = 'fail';
                  commit('UPDATE_CHAT_DATA',msg[key]);
                }
              }
            }
            commit('UPDATE_CHAT_DATA',state.patService);
            resolve();
          })
      })
    },
    addRecord({commit},payload){
      if(payload.data.type == 'img'){
        commit('SET_IMG_ARR',{way : 'unshift',msg : payload},{root : true});
      }
      if(payload.data.type == 'inquiry_service'){
        if(payload.data.ill_imgs.length != 0){
          let ill_img = payload.data.ill_imgs;
          for(let j= 0; j < ill_img.length ; j ++){
            commit('SET_IMG_ARR',{way : 'unshift' ,msg : ill_img[j].path},{root : true});
          }
        }
        if(payload.data.drug_imgs.length != 0){
          let drug_img = payload.data.drug_imgs;
          for(let k= 0; k < drug_img.length ; k ++){
            commit('SET_IMG_ARR',{way : 'unshift' ,msg : drug_img[k].path},{root : true});
          }
        }
      }
      commit('UPDATE_CHAT_RECORD',payload);
    },
    unReadChatCount({commit,state},payload){
      let arr = [];
      api.myInquiries({status : 1 , page : 0}).then(obj=>{
        obj.orders.forEach((v)=>{
          arr.push(v.account);
        })
        window.sessionStorage['unReadTipCount'] = JSON.stringify(arr);
      })
    }

  }
}
export default chat;



// WEBPACK FOOTER //
// ./src/vuex/modules/chat.js